import Select, { Props } from 'react-select';
import { SortableContainer, SortableContainerProps } from 'react-sortable-hoc';

export const SelectSortableContainer = SortableContainer(Select) as React.ComponentClass<
  Props & SortableContainerProps
>;
